import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Popover } from 'react-tiny-popover';

export default function GenAIMyAvatar({ avatarBg = "#0F68B2",
    outerAccent = "#8C3BBB", }) {
    const [initials, setInitials] = useState("");
    const [display, setDisplay] = useState(false);
    const history = useHistory();
    const isRussian = JSON.parse(localStorage.getItem('russianuser'));
    const myProfilePopup = () => {
        setDisplay(!display)
    }
    useEffect(() => {
        try {
            let username = JSON.parse(localStorage.getItem('userdisplayName'));
            if (username) {
                let userNameSplit = username.split(" ");
                if (userNameSplit.length > 1) {
                    let firstName = userNameSplit[0];
                    let lastName = userNameSplit[1];
                    setInitials(`${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`)
                } else {
                    setInitials(`${username[0].toUpperCase()}`)
                }
            }
        } catch (error) {
        }
    }, []);
    return (<>

        <Popover
            isOpen={display}
            positions={['bottom']}
            align={'end'}
            containerClassName="react-tiny-popover-container"
            scrollable
            containerStyle={{
                top: '-5px',
                left:"-35px",
                zIndex: 1,
            }}
            onClickOutside={(e) => {
                if (!(e && e.srcElement && e.srcElement.classList && (e.srcElement.classList.contains('popoverAvoidClickOutside') || e.srcElement.closest(".react-tiny-popover-container")))) {
                    setDisplay(false);
                }
            }}
            content={(positions, align) => (<ul className="genAIRecommended-main-navigation-sub-menu-wrapper" >
                <li onClick={(e) => { history.push('/recommended') }}>Home</li>
                <li onClick={(e) => {
                    if (isRussian) {
                        window.location.href = `${window.location.origin}/register-role`;
                    }
                    else {
                        window.location.href = `${window.location.origin}/registration`;
                    }
                    setDisplay(false)
                }}>View/Edit Preferences</li>
                <li onClick={(e) => { setDisplay(false); window.open("/ManageAlerts") }}>Alerts</li>
                <li onClick={(e) => { window.open('/Get-Help') }}>Access Training Materials</li>
                <li onClick={(e) => { window.open('/Contact-Us') }}>Contact Us</li>
            </ul>)}>
            <div className="ccai-avatar-wrap" onClick={myProfilePopup}>
                <div
                    className="ccai-avatar-outer"
                    style={{ background: outerAccent }}
                    aria-hidden="true"
                >
                    <div
                        className="ccai-avatar-inner"
                        style={{ background: avatarBg }}
                    />
                    <div className="ccai-avatar-overlay" />
                    <div className="ccai-initials">{initials}</div>
                </div>
            </div>
        </Popover>
    </>)

}